module.exports = __webpack_public_path__ + "img/ey.067e0f8e.png";